import { isVideoMedia } from "../../data/caseStudyMedia";
import "./CaseOpen.css";

export default function CaseOpen({
  src,
  alt,
  eyebrow,
  title,
  dek,
  meta = [],
  overviewId = "overview",
}) {
  const isVideo = isVideoMedia(src);

  return (
    <section className="case-open" aria-label="Project overview">
      <div className="case-open__frame">
        <figure className="case-open__media">
          {isVideo ? (
            <video src={src} autoPlay muted loop playsInline aria-label={alt} />
          ) : (
            <img src={src} alt={alt} />
          )}
        </figure>
        <header className="case-open__overview" id={overviewId}>
          {eyebrow ? <p className="case-open__eyebrow">{eyebrow}</p> : null}
          <h1 className="case-open__title">{title}</h1>
          {dek ? <p className="case-open__dek">{dek}</p> : null}
          {meta.length > 0 && (
            <dl className="case-open__meta">
              {meta.map(({ label, value }) => (
                <div key={label}>
                  <dt>{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
          )}
        </header>
      </div>
    </section>
  );
}
